import React from "react";
import HydrationSafeSlider from "../../components/HydrationSafeSlider";

export default function HomeNews() {
  const logos = [
    { image: "/assets/images/brand-logo1.webp", title: "Brand 1" },
    { image: "/assets/images/brand-logo2.webp", title: "Brand 2" },
    { image: "/assets/images/brand-logo3.webp", title: "Brand 3" },
    { image: "/assets/images/brand-logo4.webp", title: "Brand 4" },
    { image: "/assets/images/brand-logo5.webp", title: "Brand 5" },
    { image: "/assets/images/brand-logo6.webp", title: "Brand 6" },
    { image: "/assets/images/brand-logo2.webp", title: "Brand 7" },
    { image: "/assets/images/brand-logo3.webp", title: "Brand 8" },
    { image: "/assets/images/brand-logo4.webp", title: "Brand 9" },

  ];

  const settingslogos = {
    dots: false,
    slidesToShow: 7,
    infinite: true,
    autoplay: true,
    slidesToScroll: 1,
    pauseOnHover: false,
    arrows: false,
    cssEase: "linear",
    initialSlide: 0,
   autoplaySpeed: 0,
    speed: 3000,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 599,
        settings: {
          slidesToShow: 3,
        },
      },
    ],
  };


  return (
    <>
      <section className="home-news space">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="news-text heading-gap">
                <h2 className="heading heading-center">In The News</h2>
              </div>
            </div>
          </div>

        </div>

        <HydrationSafeSlider {...settingslogos} className="home-brand-slider">
          {logos.map((logo, index) => (
            <div className="homepartner-box" key={index}>
              <div className="partner-inner">
                <img src={logo.image} alt={logo.title} className="img-responsive" loading="lazy" />
              </div>
            </div>
          ))}
        </HydrationSafeSlider>
      </section>

    </>
  )
}




